

function initializeMobileNavToggle() {

const navToggleButton = document.querySelector(".navbar-toggle");
const primaryNavigation = document.querySelector(".navigation-bar");

	if (navToggleButton) {

		navToggleButton.addEventListener("click", () => {
			primaryNavigation.classList.toggle("nav-is-open");
			navToggleButton.classList.toggle("open");
			//document.querySelector.toggle("body").classList.toggle("no-scroll"); //Not being used, but added in case we do want it later.
		})
	}
};

export {
	initializeMobileNavToggle
}
